import React, { useEffect, useState } from "react";
import { LandingNav } from "@/components/landing/LandingNav";
import { HeroSection } from "@/components/landing/HeroSection";
import { StatBand } from "@/components/landing/StatBand";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { HowSection } from "@/components/landing/HowSection";
import { FeaturesSection } from "@/components/landing/FeaturesSection";
import { CompareSection } from "@/components/landing/CompareSection";
import { TestimonialSection } from "@/components/landing/TestimonialSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { FaqSection } from "@/components/landing/FaqSection";
import { FinalCta, LandingFooter } from "@/components/landing/FinalCta";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const [lang, setLang] = useState(
    () => localStorage.getItem("dpc_lang") || "en"
  );

  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
    localStorage.setItem("dpc_lang", lang);
  }, [lang]);

  useEffect(() => {
    document.body.dataset.page = "landing";
    return () => {
      delete document.body.dataset.page;
    };
  }, []);

  return (
    <div className="landing-root">
      <div className="ticker-line" />
      <LandingNav lang={lang} setLang={setLang} />
      <HeroSection lang={lang} />
      <StatBand lang={lang} />
      <ProblemSection lang={lang} />
      <HowSection lang={lang} />
      <FeaturesSection lang={lang} />
      <CompareSection lang={lang} />
      <TestimonialSection lang={lang} />
      <PricingSection lang={lang} />
      <FaqSection lang={lang} />
      <FinalCta lang={lang} />
      <LandingFooter lang={lang} />
      <Footer />
    </div>
  );
}
